import { Dispatch, SetStateAction } from 'react';
import { WarningModal } from 'components/Modal/warning';
import { Stack } from 'components/Stack';
import { Text } from 'components/Typography';

type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  errorMessage: string;
};

const RequestErrorModal = ({ isOpen, setIsOpen, errorMessage }: Props) => {
  return (
    <WarningModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      description={
        <>
          <>
            <Text styleName="body2" color="RG02">
              {errorMessage}
            </Text>
          </>
          <Text styleName="body2" color="RG02">
            확인 후 재요청 해주세요
          </Text>
        </>
      }
    />
  );
};

export default RequestErrorModal;
